/* eslint-disable */
import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/HomePage.vue'
import ListDocuDigitali from '../views/ListDocuDigitali.vue'
import ChiSiamo from '../views/ChiSiamo.vue'
import SchedaDettaglio from '../views/SchedaDettaglioOpen.vue'
import Cookies from '../views/Cookies.vue'

Vue.use(VueRouter)

const routes = [{
    path: '*',
    redirect: {
      name: 'HomePage'
    },
  },
  {
    path: '/' + process.env.VUE_APP_WEB2PYSITE,
    name: 'HomePage',
    component: Home
  },
  {
    path: '/' + process.env.VUE_APP_WEB2PYSITE + '/default/index',
    name: 'HomePageSame',
    component: Home
  },
  {
    path: '/' + process.env.VUE_APP_WEB2PYSITE + '/default/index/grid',
    name: 'ListDocuDigitali',
    component: ListDocuDigitali
  },
  {
    path: '/' + process.env.VUE_APP_WEB2PYSITE + '/default/index/chi_siamo',
    name: 'ChiSiamo',
    component: ChiSiamo
  },
  //per la gestione del refresh su web2py vanno ripetute
  {
    path: '/' + process.env.VUE_APP_WEB2PYSITE + '/schede/scheda_dettaglio/:id',
    name: 'SchedaDettaglio',
    component: SchedaDettaglio
  },
  {
    path: '/' + process.env.VUE_APP_WEB2PYSITE + '/default/index/schede/scheda_dettaglio/:id',
    name: 'SchedaDettaglio',
    component: SchedaDettaglio
  },
  {
    path: '/' + process.env.VUE_APP_WEB2PYSITE + '/index/schede/scheda_dettaglio/:id',
    name: 'SchedaDettaglio',
    component: SchedaDettaglio
  },
  {
    path: '/' + process.env.VUE_APP_WEB2PYSITE + '/default/index/cookies',
    name: 'Cookie',
    component: Cookies
  },
]

const router = new VueRouter({
  mode: 'history',
  routes
})

export default router
